export class Cai {
  id: number = -1;
  codTipoDocImp: string = "RE";
  letra: string = "";
  ptoEmision: string = "0015";
  fecDesdeCai: Date = new Date();
  fecVtoCai: Date = new Date();
  nroCai: string = "";
  estado: boolean = true;
  usrCreacion: string = "";
  fecCreacion: Date = new Date();
  usrModif: string | null = null;
  fecModif: Date | null = null;
}
